/**
 * @file
 * Behaviors for the session.
 */

!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.sessionArrows = {
    attach: function() {
      const wrappers = document.querySelectorAll(
        '.session-detail__link-wrapper'
      );
      if (!wrappers.length) {
        return;
      }

      const path = window.location.pathname;

      function hrefPath(anchor) {
        const raw = anchor.getAttribute('href') || '';
        const queryIndex = raw.indexOf('?');
        const hashIndex = raw.indexOf('#');
        let cut = raw.length;
        if (queryIndex !== -1) {
          cut = queryIndex;
        }
        if (hashIndex !== -1 && hashIndex < cut) {
          cut = hashIndex;
        }
        return raw.substring(0, cut);
      }

      // Mark the current page link in every session-arrow views block.
      const allLinks = document.querySelectorAll(
        '.session-arrow a.session-detail__link'
      );
      allLinks.forEach(link => {
        if (hrefPath(link) === path) {
          const row = link.closest('.views-row');
          if (row) {
            row.classList.add('current');
          }
        }
      });

      function markArrow(currents, direction) {
        if (!currents.length) {
          return;
        }
        const anchor = direction === 'next'
          ? currents[currents.length - 1]
          : currents[0];
        const sibling = direction === 'next'
          ? anchor.nextElementSibling
          : anchor.previousElementSibling;
        if (sibling) {
          sibling.classList.add('arrow');
        }
      }

      markArrow(
        document.querySelectorAll(
          '.session-detail__link-wrapper--top .session-next .current'
        ),
        'next'
      );
      markArrow(
        document.querySelectorAll(
          '.session-detail__link-wrapper--bottom .session-next .current'
        ),
        'next'
      );
      markArrow(
        document.querySelectorAll(
          '.session-detail__link-wrapper--top .session-prev .current'
        ),
        'prev'
      );
      markArrow(
        document.querySelectorAll(
          '.session-detail__link-wrapper--bottom .session-prev .current'
        ),
        'prev'
      );

      const unused = document.querySelectorAll(
        '.session-arrow .views-row:not(.arrow):not(.current)'
      );
      unused.forEach(row => row.remove());

      function arrowDisplay(sessionWrapper) {
        const $container = $(sessionWrapper).find('.views-element-container');
        $container.each(function(index, el) {
          if (index > 1) {
            $(el).addClass('hidden');
          }
          else {
            const $row = $(el).find('.session-arrow .views-row.arrow');
            $row.each(function(indexValue, element) {
              $(element).css('display', 'none');
              if (indexValue === 0) {
                $(element).css('display', 'block');
              }
            });
          }
        });
      }

      arrowDisplay('.session-detail__link-wrapper--top');
      arrowDisplay('.session-detail__link-wrapper--bottom');
    }
  };
})(Drupal, jQuery);
